import rest from "../utils/rest";

export const customerInitialRests = async () => {
  const meRest = rest
    .get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/customers/me`)
    .then((resp) => resp?.data || {})
    .catch(() => ({ error: true }));

  const tokensMeRest = rest
    .get(`${process.env.REACT_APP_AUTH_SERVICE}/api/tokens/me`)
    .then((resp) => resp?.data || {})
    .catch(() => ({ error: true }));

  const balanceRest = rest
    .get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/customers/me/balance`)
    .then((resp) => resp?.data?.balance || 0)
    .catch(() => ({ error: true }));

  const lastUnreadMsgMeRest = rest
    .get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/notifications/three-last-of-unread-notifications`)
    .then((resp) => resp?.data || [])
    .catch(() => []);

  const me = await meRest;

  const tokensMe = await tokensMeRest;

  const balanceMe = await balanceRest;

  const lastUnreadMsgMe = await lastUnreadMsgMeRest;

  return { me, tokensMe, balanceMe, lastUnreadMsgMe };
};

export const resellerInitialRests = async () => {
  const meRest = rest
    .get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/employees/me`)
    .then((resp) => resp?.data || {})
    .catch(() => ({ error: true }));

  const tokensMeRest = rest
    .get(`${process.env.REACT_APP_AUTH_SERVICE}/api/tokens/me`)
    .then((resp) => resp?.data || {})
    .catch(() => ({ error: true }));

  const me = await meRest;
  const tokensMe = await tokensMeRest;

  return {
    me,
    tokensMe,
  };
};

export const employeeInitialRests = async () => {
  const meRest = rest
    .get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/employees/me`)
    .then((resp) => resp?.data || {})
    .catch(() => ({ error: true }));

  const me = await meRest;

  return { me };
};
